import React, {useState, useEffect } from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
    Grid,
    Typography,
    TextField,
} from '@material-ui/core';
import {ButtonTextMUI as Button} from "utils/componentsStyle";
import {red, green, orange, indigo} from "@material-ui/core/colors";
import ModalDialog from "views/Widgets/Common/ModalDialog";
import api from "utils/API";
import TableComponent from "views/Widgets/Common/TableComponent";
import TabCommon from "views/Widgets/Common/TabCommon";
import {setmessageGeneral } from "actions/getGlobalAction";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

export default function ModalAlertStock({
    open,
    closeModal,
    rowInfo,
    setinitialCharge,
}) {
    const dispatch = useDispatch();

    const handleEndWork = () => {
        const body = {
            estado: "Completado",
        }
        api.patch(`api/tareaspaciente/${rowInfo.id}`, body ).then((response) => {
            setmessageGeneral(dispatch, response.data.mensaje, "success", "¡Exito!");
            setinitialCharge(true)
            closeModal()
        })
    }

    const patientData = rowInfo.id_ficha.id_paciente
    const patientName = `${patientData.nombre} ${patientData.apellido_paterno} ${patientData.apellido_materno}`

    const _content_ = <div>
        <Grid
            direction="row"
            justify="center"
            alignItems="center"
            item xs={12}
            style={{padding: "5px", width: "100%"}
        }>
            <Typography component="body2" variant="body2"  style={{fontWeight: 'bold'}} >
                {`Se ha generado una alerta de Stock en el paciente ${patientName} del item - ${rowInfo.descripcion}, se recomienda reponer stock realizando un pedido de insumos y medicamentos o desde una solicitud de pedidos programados`}
            </Typography>
        </Grid>

    </div>

    const _actions_ = <>
        <Button
            mr={2}
            variant="contained"
            style={{backgroundColor: indigo[500]}}
            className="text-white"
            onClick={handleEndWork}
        >
            Confirmar
        </Button>
        <Button
            mr={2}
            variant="contained"
            style={{backgroundColor: red[500]}}
            className="text-white"
            onClick={closeModal}
        >
            Cerrar
        </Button>
    </>


    return (
        <>
        <ModalDialog
            open={open}
            onClose={closeModal}
            title={`Alerta de Stock`}
            _content_={_content_}
            _actions_ = {_actions_}
            maxWidth="xs"
        />
        </>

    );
}